<template>
  <div class="registerb">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" >
      <div class="Rtitle">
        <span class="titlel">{{ InsName }}代理管理后台</span><span class="titler"> | 忘记密码</span>
      </div>
      <div class="Rmin" v-show="insTestProp.AgentRelyPhone">
      <el-form-item prop="name">
        <div class="error3">
         <span class="colorr">*</span> <span>代理代码:</span>
        </div>
        <el-input v-model.trim="ruleForm.name" placeholder="请输入代理人代码" id="name"></el-input>
      </el-form-item>
      <el-form-item prop="phone">
        <div class="error3">
         <span class="colorr">*</span> 手机号:
        </div>
        <el-input v-model.trim="ruleForm.phone" placeholder="请输入手机号" id="phone"></el-input>
        <span class="error4 hint">请填写账户绑定的手机号码.</span>
      </el-form-item>
      <el-form-item >
        <div class="error3">
         <span class="colorr">*</span> 图形验证码:
        </div>
        <el-input v-model.trim="ruleForm.code" placeholder="请输入图形验证码" id="imgcode"></el-input>
        <img :src="imgurl" alt="" class="imgcode" @click="GetImgCheckCode()">
      </el-form-item>
      <el-form-item prop="phoneCode">
        <div class="error3">
         <span class="colorr">*</span> 手机验证码:
        </div>
        <el-input v-model.trim="ruleForm.phoneCode" placeholder="请输入的验证码"  id="code"></el-input>
        <el-button type="primary" size="small" @click="sendCode('ruleForm')" :disabled="isDisabled">{{buttonName}}</el-button>
      </el-form-item>
        <div class="bbbtn">
          <el-button type="primary" @click="submitForm('ruleForm')" class="submit" :disabled="this.isDisableds">确认</el-button>
          <el-button @click="resetForm('ruleForm')" class="submit">重置</el-button>
        </div>
      </div>
      <div style="font-size: 32px;text-align: center" v-show="!insTestProp.AgentRelyPhone">
        请联系管理员!
      </div>
    </el-form>
  </div>

</template>

<script>
import "./assets/lib/jquery.min.js";

export default {
  name: "forgetPswd",
  data() {
    var reg = /^1\d{10}$/;
    var validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电话号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
        this.codephone = true;
      }
    };
    return {
      whoAccout:"",
      isDisableds: false,
      InsName: "",
      InsNameEn: "",
      codephone: false,
      checked: false,
      buttonName: "发送短信验证码",
      isDisabled: false,
      time: 60,
      ruleForm: {
        name: "",
        phone: "",
        phoneCode: "",
        InsCode: "",
      },
      rules: {
        name: [
          {
            required: true,
            min: 2,
            max: 50,
            message: "请输入真实姓名",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, trigger: "blur", validator: validPhone } //这里需要用到全局变量
        ],
        phoneCode: [
          {
            required: true,
            message: "请输入正确的验证码",
            trigger: "blur"
          }
        ],
      },
      path: "",
      imgurl:"",
      second: "获取验证码",
      flag: true,
      timer: null, // 该变量是用来记录定时器的,防止点击的时候触发多个setInterval,
      s:"",
      insTestProp: {
        IsTestIns: true, // 是否测试机构，true测试机构
        AgentRelyPhone: true, // 依赖手机号
        UseCustomId: true // 使用自定义ID,false表示使用系统自动生成，true表示使用自定义ID
      }
    };
  },
  created(){
    this.InsName = JSON.parse(sessionStorage.getItem("InsNameCn"));
    this.InsNameEn = JSON.parse(sessionStorage.getItem("InsNameEn"));
    document.getElementsByTagName("title")[0].innerText = '忘记密码';
    var pswdpageiscode = sessionStorage.getItem("pswdpageiscode" );
    this.whoAccout = sessionStorage.getItem("whoAccout" );
    if(pswdpageiscode == null){
       pswdpageiscode = window.location.hash.split("?")[0].slice(1, 20);
      this.ruleForm.InsCode = pswdpageiscode.split("/")[2];
    }else{
      this.ruleForm.InsCode = pswdpageiscode.split("/")[2];
    }
    // console.log(this.ruleForm.InsCode);
    this.getInsTestPropFn();
    this.GetImgCheckCode();
  },
  methods: {
    getInsTestPropFn() {  // 获取机构性质
      var insCode = this.ruleForm.InsCode;
      var postData = "insCode=" + insCode;
      var url = "/openinsuser/GetInsTestProp";
      this.$indexapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.insTestProp = response.Data;
        } else {
          this.$alert(response.Msg);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 确认按钮
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid  === true) {
          if(this.whoAccout == "false"){
            this.isDisableds = true;
            let url = "Login/AgentForgetPassword";
            let postData =
              "insCode=" +
              this.ruleForm.InsCode +
              "&agentCode=" +
              this.ruleForm.name +
              "&phone=" +
              this.ruleForm.phone +
              "&code=" +
              this.ruleForm.phoneCode;
              this.$indexapi.post(url, postData, response => {
              this.isDisableds = false;
              if (response.Ret == 0) {
                vue.$message.success("密码重置成功！自动跳转登录页面！");
                      $("#name").val("");
                      $("#phone").val("");
                      $("#code").val("");
                      setTimeout(() => {
                        this.$router.push("/");
                      }, 1000);
              } else {
                this.$message.error(response.Msg);
                this.resetForm('ruleForm');
              }
            });
          }else{
            this.isDisableds = true;
            let url = "Login/AgentAccountForgetPassword";
            let postData =
              "AgentAccountCode=" +
              this.ruleForm.name +
              "&Phone=" +
              this.ruleForm.phone +
              "&Code=" +
              this.ruleForm.phoneCode +
              "&InsCode=" +
              this.ruleForm.InsCode ;
              this.$indexapi.post(url, postData, response => {
              this.isDisableds = false;
              if (response.Ret == 0) {
                vue.$message.success("密码重置成功！自动跳转登录页面！");
                      $("#name").val("");
                      $("#phone").val("");
                      $("#code").val("");
                      setTimeout(() => {
                        this.$router.push("/");
                      }, 1000);
              } else {
                this.$message.error(response.Msg);
                this.resetForm('ruleForm');
              }
            });
          }
        } else {
          vue.$message.error("信息输入有误！");
          return false;
        }
      });
    },
            //  获取图形验证码
    GetImgCheckCode(){
        this.$indexapi.post(
        "/login/GetImgCheckCode/", "id=" + this.ruleForm.InsCode,
        response => {
            if (response.Ret == 0) {  
              this.imgurl = "data:image/png;base64," + response.Data.ImageBase64;
              this.ImageCheckSign = response.Data.ImageCheckSign;
            } else {
              this.$message.error(response.Msg);    
            }
        });           
    },
    //获取验证码
    sendCode(formName) {
      if(this.ruleForm.phone == ""){
        this.$message.error({
          duration:1000,
          message:"请输入手机号"
          });
        return;
      }
      if(this.ruleForm.code == ""){
        this.$message.error(
          {
          duration:1000,
          message:"请输入图形验证码"
          });
        return;
      }    
      this.$refs[formName].validateField("phone",valid => {
          if (valid === "") {
            let url = "login/SendSmsCodeWithImageCode";
            this.$indexapi.post(url, 
            "insCode=" + this.ruleForm.InsCode + "&agentCode=" + this.ruleForm.name + "&phone=" + this.ruleForm.phone + "&imageCode=" + this.ruleForm.code + "&imageCheckSign=" + this.ImageCheckSign + "&id=" + this.ruleForm.InsCode,
             response => {
              if (response.Ret == 0) {
                this.$message.success("验证码已发送，请注意查收!");
                let that = this;
                if (that.flag) {
                  that.second = 60;
                  that.s = "s";
                  that.flag = false;
                  let interval = window.setInterval(function() {
                  that.setStorage(that.second);
                  if (that.second-- <= 1) {
                    that.second = "获取验证码";
                    that.s = "";
                    that.flag = true;
                    window.clearInterval(interval);
                  }
                  }, 1000);
                } 
              } else {
                this.$message.error(response.Msg);
                this.GetImgCheckCode();
              }
            });
          } else {
            vue.$message.error("信息输入有误！");
            this.flag = true;
            return false;
          }
      })

    },
        setStorage(parm) {
        localStorage.setItem("dalay", parm);
        localStorage.setItem("_time", new Date().getTime());
        },
        getStorage() {
        let localDelay = {};
        localDelay.delay = localStorage.getItem("dalay");
        localDelay.sec = localStorage.getItem("_time");
        return localDelay;
        },
        judgeCode() {
        let that = this;
        let localDelay = that.getStorage();
        let secTime = parseInt(
          (new Date().getTime() - localDelay.sec) / 1000
        );
        if (secTime > localDelay.delay) {
          that.flag = true;
        } else {
          that.s = "s";
          that.flag = false;
          let _delay = localDelay.delay - secTime;
          that.second = _delay;
          that.timer = setInterval(function() {
          if (_delay > 1) {
            _delay--;
            that.setStorage(_delay);
            that.second = _delay;         
            that.flag = false;
          } else {
      　　　 that.second = "获取验证码";
            that.s = "";　　　　　　　　　　　
      　　　// 此处赋值时为了让浏览器打开的时候,直接就显示剩余的时间
            that.flag = true;
            window.clearInterval(that.timer);
          }
          }, 1000);
        }
        }
  }
};
</script>


<style scoped>
.registerb .Rtitle,
.registerb .Rmin {
  min-width: 1000px;
}
.el-input {
  width: 50% !important;
}
.imgcode{
    position: absolute;
    left: 375px;
    top: 38px;
}
</style>



// WEBPACK FOOTER //
// src/forgetPswd.vue